/**
 * Centralized timeblock color definitions
 * Used across dashboard, schedule, and timeblock views
 */

export const BLOCK_COLORS = {
  'office time': '#C45D3A',
  'plan & organize': '#7C5CBF',
  'projects': '#3B82C4',
  'delegate and inspect': '#2D8A5F',
  'morning start': '#C44D7A',
  'eod wrap-up': '#5B6BD4',
};

export const DEFAULT_EVENT_COLOR = '#64748b';

/**
 * Get the color for a timeblock by its summary/name
 * @param {string} summary - Event summary (e.g., "Office Time", "Projects")
 * @returns {string|null} Color hex code or null if not a timeblock
 */
export function getBlockColor(summary) {
  const name = summary?.toLowerCase() || '';
  for (const [key, color] of Object.entries(BLOCK_COLORS)) {
    if (name.includes(key)) return color;
  }
  return null;
}

/**
 * Get the color for any event (timeblock or regular event)
 * @param {string} summary - Event summary
 * @returns {string} Color hex code
 */
export function getEventColor(summary) {
  return getBlockColor(summary) || DEFAULT_EVENT_COLOR;
}

/**
 * Get a very subtle background tint for task cards (12% opacity)
 * @param {string} hexColor - Hex color code
 * @returns {string} Hex color with alpha
 */
export function getTaskTintBackground(hexColor) {
  return `${hexColor}1F`; // 12% alpha
}

/**
 * Convert hex to light background (8% color, 92% white)
 * @param {string} hexColor - Hex color code
 * @returns {string} RGB color string
 */
export function getLightBackground(hexColor) {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const lightR = Math.round(r * 0.08 + 255 * 0.92);
  const lightG = Math.round(g * 0.08 + 255 * 0.92);
  const lightB = Math.round(b * 0.08 + 255 * 0.92);
  return `rgb(${lightR}, ${lightG}, ${lightB})`;
}
